import * as t from 'io-ts';

import {makeApiType} from './apiTypes';

/*
 * Runtime type.
 */

const RCrmMetadataBase = t.readonly(
  t.type({
    crmResourceCount: t.number,
  }),
);

const RCrmMetadata = t.intersection([
  RCrmMetadataBase,
  t.type({
    mappingOptions: t.readonly(t.record(t.string, t.readonlyArray(t.string))),
  }),
]);

/*
 * Type.
 */

export interface CrmMetadataModel extends t.TypeOf<typeof RCrmMetadata> {}

/*
 * IO methods.
 */

export function parseCrmMetadata(src: any): CrmMetadataModel {
  return {
    crmResourceCount: src.crm_resource_count,
    mappingOptions: src.mapping_options,
  };
}

/*
 * API type.
 */

export const ApiCrmMetadata = makeApiType('crmMetadata', RCrmMetadata, parseCrmMetadata);
